import TeamLayout from "components/Team/TeamLayout";

export default TeamLayout;
